import { gql } from "@apollo/client";

const SEARCH_ASSET_GLOBAL = gql`
  query masterSearch($search: String) {
    masterSearch(search: $search) {
      id
      make {
        name
      }
      model {
        name
      }
      category {
        name
      }
      manufactured
    }
  }
`;

export { SEARCH_ASSET_GLOBAL };
